export const CURRENT_CONFIG = {

  // license
  appId: '175156', // You need to go to the development website to apply.
  appKey: '9313daa4297514f568b7eb050ad5e20', // You need to go to the development website to apply.
  appLicense: 'xHIRkdKphf33/C57kgTZj6qEYiRcElYIluNN0cAZaVFrQ5Oe3hNAykBgZYlCkU4XBJckaJNehtQzO59yvIJIBbLd9ZhXTxyUJTd8JhxBJNi08XJzYHhfI7l6xdpu8MglxN8C/uBoH2zSu07q5U5W2QncY+5T6su5SXzkePS4wwI=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://api.dji.xtzl.net/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'https://api.dji.xtzl.net/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://live.xtzl.net/demo/mreq', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'c51f0f8aa04335df00a4238a26572814',

}
